<template>
  <transition name="move">
    <div class="result-list-box" ref="wrap" v-show="relevantControl.list.length > 0">
      <ul class="result-lists">
        <li
          class="result-list"
          v-for="(item, index) in relevantControl.list"
          :key="index"
          @click="handleRowClick(item)"
          v-html="item.titleCopy"
        ></li>
      </ul>
      <i v-if="tipVisible" class="iconfont glin-zuoxiahuadong"></i>
    </div>
  </transition>
</template>

<script>
import BScroll from 'better-scroll'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      tipVisible: true
    }
  },
  computed: {
    ...mapState(['chatControl', 'sendControl', 'relevantControl'])
  },
  mounted () {
    const scroll = new BScroll(this.$refs.wrap, {
      click: true,
      taps: true,
      scrollY: true
    })
    scroll.on('scrollStart', () => {
      this.tipVisible = false
    })
  },
  methods: {
    handleRowClick (row) {
      row.suggestions = this.relevantControl.list
        .filter(item => item.id !== row.id)
        .slice(0, 5)
      this.relevantControl.clear()
      this.sendControl.clear()
      this.chatControl.addInfoByArticle(row)
    }
  }
}
</script>

<style lang="stylus">
.result-list-box {
  position: fixed;
  left: 0;
  bottom: 50px;
  z-index: 97;
  background: #fff;
  width: 100%;
  overflow-y: auto;
  max-height: 224px;
  box-shadow: 7px 6px 15px #696767;
  border-top: 1px solid #e4e4e4;
  background: #eff4f7;

  &.move-enter-active, &.move-leave-active {
    transition: all 0.2s linear;
    transform: translate3d(0, 0, 0);
  }

  &.move-enter, &.move-leave-active {
    transform: translate3d(0, 100%, 0);
  }

  .result-lists {
    padding: 0 15px;

    .result-list {
      border-bottom: 1px solid #e4e4e4;
      padding: 11px 0;

      &:last-child {
        border-bottom: none;
      }

      span {
        color: red;
      }
    }
  }

  .iconfont {
    position: fixed;
    right: 15px;
    bottom: 138px;
    z-index: 1001;
    color: #193a79;
    font-size: 2rem;
    animation: toggleMove 0.8s infinite;
  }
}

@keyframes toggleMove {
  0% {
    bottom: 142px;
    opacity: 0.3;
  }

  50% {
    bottom: 137px;
    opacity: 1;
  }

  to {
    bottom: 142px;
    opacity: 0.3;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/relevantList.vue